import { defineComponent } from "vue";

const name = 'g-card'


export default defineComponent({
  name,
  props: {
    cor:{
      type: String,
      default: '#ffffff',
    },
    altura: {
      type: String,
      default: '100%'
    },
    largura: {
      type: String,
      default: 'auto'
    },
    titulo: {
      type: String,
      default: ''
    },
    expansivel: {
      type: Boolean,
      default: false,
    },
    sombreado: {
      type: Boolean,
      default: false,
    },
    fonteTitulo: {
      type: String,
      default: 'Arial'
    },
    paddingDefault: {
      type: String,
      default: '0 1em 4em'
    },
    bordaRedonda: {
      type: Boolean,
      default: true,
    },
    comecaFechado: {
      type: Boolean,
      default: false,
    },
    temCabecalho: {
      type: Boolean,
      default: true,
    },
    corTitulo: {
      type: String,
      default: '#000000',
    },
    negritoTitulo: {
      type: Boolean,
      default: false
    },
    corCabecalho: {
      type: String,
      default: '#ffffff'
    },
    minAltura: {
      type: String,
      default: '100px'
    },
    iconeEsquerda: {
      type: String,
      default: null
    },
    iconeDireita: {
      type: String,
      default: null
    },
    fontSizeTitulo:{
      type: String,
      default: '14px'
    },
    margem: {
      type: String,
      default: '20px'
    },
    paddingFiltro: {
      type: String,
      default: '20px 10px 20px 30px'
    },
    larguraCResumoLateral: {
      type: Boolean,
      default: true
    },
    setaExpansivelMarrom: {
      type: Boolean,
      default: false,
    },
  },
  created () {
    if (!this.expansivel && this.comecaFechado) {
      throw new Error('Um card não pode possuir a propriedade "comecaFechado" sem possuir a propriedade "expansivel"')
    }
  },
  mounted () {
    this.alturaCard = this.altura !== '100%' ? this.altura:`${this.$refs.containerCard.clientHeight}px`
    if (this.cabecalhoCustomizado){
      this.displayCabecalho = 'flex'
    }
    if (this.expansivel) {
      this.cardGridAreas = '"titulo icone-expandir"'
      this.cardTemplateColumns = '85% 15%'
    }

  },
  data() {
    return {
      expandido: !this.comecaFechado,
      alturaCard: '',
      temBordaTop: true,
      rotacaoIconeExpandir: !this.comecaFechado ? '360deg' : '180deg',
      cardGridAreas: '"titulo icone-direita"',
      cardTemplateColumns: '85% 15%',
      displayCabecalho: 'grid',
      cabecalhoCustomizado: this.$slots.cabecalho !== undefined
    };
  },
  methods : {
    expandirConteudo () {
      if (this.expandido) {
        this.rotacaoIconeExpandir = '180deg'
      } else {
        this.rotacaoIconeExpandir = '360deg'
      }
      this.expandido = !this.expandido
      this.temBordaTop = !this.temBordaTop
    }

  },
  computed: {
    weightTitulo () {
      return this.negritoTitulo ? 'bold':'normal'
    },
    alturaFechado () {
      return `${this.$refs.cabecalho.clientHeight}px`
    },
    alturaMinima () {
      return this.expansivel ? `${this.$refs.cabecalho.clientHeight}px` : this.minAltura
    },
    displayConteudo () {
      return this.expandido ? 'block' : 'none'
    },
    displayDivisor () {
      return this.expandido ? 'block' : 'none'
    },
    borderTopConteudo(){
      return this.temBordaTop && this.expansivel ? '1px solid #E9E9E9' : 'none'
    }
  }

});
